import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { legendsColors } from '../../config';

//ui-cmd-6

const UsageChart = ({ data, legendsList, xAxisLabels, isLoading }) => {
    const isEmpty = !data || data?.length === 0 || data.every(series => series.length === 0);
    const [chartOption, setChartOption] = useState({});

    const totalData = isEmpty || isLoading ? [] : data.map(series =>
        series.map((value, index) => legendsList[index] === 'Total Transaction' ? value : 0)
    );

    const grid = {
        left: 80,
        right: 50,
        top: 50,
        bottom: 110
    };

    const gridWidth = 800 - grid.left - grid.right;
    const gridHeight = 400 - grid.top - grid.bottom;
    const categoryWidth = gridWidth / (xAxisLabels?.length || 1);
    const barWidth = categoryWidth * 0.6;
    const barPadding = (categoryWidth - barWidth) / 2;

    let series = [];
    let elements = [];

    if (!isEmpty && !isLoading) {
        series = legendsList.map((name, sid) => {
            if (data[sid] && data[sid]?.length > 0) {
                const seriesData = data[sid].map((d, did) => d);
                if (name === "Total Transaction") {
                    return {
                        name,
                        type: 'line',
                        barWidth: '15px',
                        smooth: true,
                        data: seriesData,
                        itemStyle: {
                            color: legendsColors[name]
                        },
                        lineStyle: {
                            width: 2
                        },
                        symbol: 'circle',
                        symbolSize: 10,
                        showSymbol: true,
                        emphasis: {
                            focus: 'self',
                            // itemStyle: {
                            //     color: legendsColors[name],
                            //     borderColor: legendsColors[name],
                            //     borderWidth: 2
                            // }
                        }
                    };
                } else {
                    return {
                        name,
                        type: 'bar',
                        stack: 'total',
                        barWidth: '15px',
                        data: seriesData,
                        itemStyle: {
                            color: legendsColors[name]
                        },
                        emphasis: {
                            focus: 'self',
                            // itemStyle: {
                            //     color: legendsColors[name],
                            //     borderColor: legendsColors[name],
                            //     borderWidth: 2
                            // }
                        }
                    };
                }
            }
            return null;
        }).filter(seriesItem => seriesItem !== null);

        for (let j = 1, jlen = xAxisLabels?.length || 0; j < jlen; ++j) {
            const leftX = grid.left + categoryWidth * j - barPadding;
            const rightX = leftX + barPadding * 2;
            let leftY = grid.top + gridHeight;
            let rightY = leftY;
            for (let i = 0, len = series.length; i < len; ++i) {
                const points = [];
                const leftBarHeight = (data[i][j - 1] / totalData[j - 1]) * gridHeight;
                points.push([leftX, leftY]);
                points.push([leftX, leftY - leftBarHeight]);
                const rightBarHeight = (data[i][j] / totalData[j]) * gridHeight;
                points.push([rightX, rightY - rightBarHeight]);
                points.push([rightX, rightY]);
                points.push([leftX, leftY]);
                leftY -= leftBarHeight;
                rightY -= rightBarHeight;
                elements.push({
                    type: 'polygon',
                    shape: {
                        points
                    },
                    style: {
                        fill: legendsColors[i],
                        opacity: 0
                    },
                    $action: 'replace'
                });
            }
        }
    }

    useEffect(() => {
        if (data && data?.length > 0 && !isLoading) {
            setChartOption({
                legend: {
                    selectedMode: true, // Allow hover-based highlighting
                    bottom: 10,
                    left: 50,
                    itemGap: 20,
                    width: '90%',
                    padding: [0, 0],
                    data: legendsList?.map(name => ({
                        name,
                        icon: name !== "Total Transaction" ? 'circle' : undefined
                    })),
                    textStyle: {
                        padding: [0, 0, 0, 0],
                        fontFamily: 'Satoshi',
                        fontSize: '12px',
                        fontWeight: 400,
                    },
                },
                grid,
                yAxis: {
                    type: 'value',
                    name: 'Total Transaction',
                    nameLocation: 'middle',
                    nameGap: 50,
                    nameTextStyle: {
                        fontFamily: 'Satoshi',
                        fontSize: '12px',
                        fontWeight: 400,
                    },
                    splitNumber: 4,
                    axisLabel: {
                        padding: [10, 10, 10, 10],
                        fontFamily: "Satoshi",
                        fontSize: '11px',
                        fontWeight: 400,
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisLabels,
                    axisLabel: {
                        fontFamily: "Satoshi",
                        fontSize: '11px',
                        fontWeight: 400,
                        width: 40,
                        overflow: 'break'
                    }
                },
                series: series,
                graphic: {
                    elements
                },
                tooltip: {
                    trigger: 'axis',
                    padding: [10, 20, 20, 20],
                    order: 'valueDesc',
                    textStyle: {
                        fontWeight: 'normal'
                    },
                    formatter: function (params) {
                        const lineSeriesIndex = params.findIndex(item => item.seriesType === 'line');
                        if (lineSeriesIndex > -1) {
                            const lineSeries = params.splice(lineSeriesIndex, 1)[0];
                            params.unshift(lineSeries);
                        }
                        let content = `
                        <div style="width:218px">
                            <div style="font-weight: 700; padding-bottom: 8px;font-family: 'Satoshi';">${params[0].axisValueLabel}</div>
                    `;
                        params.forEach(item => {
                            content += `
                            <div style="display: flex; justify-content: space-between; font-family: 'Satoshi'; padding: 4px 0;font-size:'50px';">
                                <div>${item.marker} ${item.seriesName}</div>
                                <div>${item.data}</div>
                            </div>
                        `;
                        });
                        content += `</div>`;
                        return content;
                    }
                },
            });
        } else {
            setChartOption({
                legend: {
                    selectedMode: false,
                    bottom: 10,
                    left: 60,
                    itemGap: 20,
                    width: '90%',
                    padding: [0, 0, 0, 0],
                    data: legendsList?.map(name => ({
                        name,
                        icon: name !== "Total Transaction" ? 'circle' : undefined
                    }))
                },
                grid,
                yAxis: {
                    type: 'value',
                    name: 'Total Transaction',
                    nameLocation: 'middle',
                    nameGap: 60,
                    nameTextStyle: {
                        fontSize: 14,
                        fontFamily: 'Satoshi'
                    },
                    splitNumber: 4,
                    axisLabel: {
                        padding: [10, 10, 10, 10]
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisLabels,
                    axisLabel: {
                        padding: [0, 0, 0, 70]
                    }
                },
                series: series,
                graphic: {
                    elements: [{
                        type: 'text',
                        left: 'center',
                        top: 'middle',
                        style: {
                            text: isLoading ? 'Fetching usage data' : 'No data available',
                            fontSize: 15,
                            fontFamily: 'Satoshi',
                            fill: '#999'
                        },
                        $action: 'replace'
                    }]
                },
                tooltip: {
                    trigger: 'axis',
                },
            });
        }
    }, [data, isLoading]);

    return (
        <div id="usage-chart">
            <ReactECharts option={chartOption} style={{ height: '400px', width: '100%' }} notMerge={true} />
        </div>
    );
};

export default UsageChart;
